var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stripe-element-payment',{ref:"paymentRef",attrs:{"pk":_vm.pk,"elements-options":_vm.elementsOptions,"confirm-params":_vm.confirmParams}}),_vm._v(" "),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }